export const proQuestionsTypes = [{
    id: 1,
    label: 'Aide à la configuration',
    val: 'aide',
}, {
    id: 2,
    label: 'Demande d\'amélioration',
    val: 'demande amélio',
}, {
    id: 3,
    label: 'Problème technique',
    val: 'bug',
}, {
    id: 5,
    label: 'Autre',
    val: 'aide',
},
];

export const frontQuestionsTypes = [{
    id: 2,
    label: 'Demande d\'amélioration',
    val: 'demande amélio',
}, {
    id: 3,
    label: 'Problème technique',
    val: 'bug',
}, {
    id: 5,
    label: 'Autre',
    val: 'aide',
},
];
